import { TFunc } from 'types/common';

export class QueueLocker<T = void> {
  private _queue: Array<TFunc<T>> = [];
  private _isRunning: boolean = false;

  public enqueue(task: TFunc<T>): void {
    this._queue.push(task);
    this._runNext();
  }

  private _runNext(): void {
    if (this._isRunning) {
      return;
    }

    const task: TFunc<T> | undefined = this._queue.shift();

    if (!task) {
      return;
    }
    this._isRunning = true;

    try {
      const result: T | Promise<T> = task();
      Promise.resolve(result)
        .catch((err): void => console.error('QueueLocker error: ', err))
        .finally((): void => {
          this._isRunning = false;
          this._runNext();
        });
    } catch (err) {
      this._isRunning = false;
      this._runNext();
    }
  }
}
